import { createActions } from 'reduxsauce'

const { Types: ChatReportsTypes, Creators: ChatReportsActions } = createActions({
  resetChatReportsData: null,
  getChatReportsData: ['loading'],
  setChatReportsData: ['chats', 'limit', 'hasDataToLoad'],
  updateChatReportsData: ['payload'],
})

export { ChatReportsTypes, ChatReportsActions }
